import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { ACTIONS } from '../../constants';
import { getHelpWidgetSession } from '../api/getHelpWidgetSession';
import { clientSdk } from '../ClientSDK';
import { ISetSessionId } from '../reducers/types';
import { helpCenterService } from '../services/helpCenter';

export const useWidgetSessionId = () => {
  const dispatch = useDispatch();
  const isSDK = helpCenterService.provideRuntimeDataFromSDK;

  const getWidgetSession = useCallback(async () => {
    const widgetSession = await getHelpWidgetSession();
    return widgetSession?.sessionId;
  }, []);
  useEffect(() => {
    const getWidgetSessionId = async () =>
      isSDK ? clientSdk.getWidgetSessionId() : getWidgetSession();
    getWidgetSessionId().then((sessionId) => {
      sessionId &&
        dispatch<ISetSessionId>({
          type: ACTIONS.SET_SESSION_ID,
          sessionId,
        });
    });
  }, [dispatch]);
};
